import * as React from 'react';
import styles from './styles.module.styl';
export var TermDefinition = function (_a) {
    var id = _a.id, title = _a.title, definition = _a.definition;
    return (React.createElement("li", { className: styles.termDefinition, "data-search": title.toLowerCase() },
        React.createElement("h3", { id: id }, title),
        React.createElement("p", { dangerouslySetInnerHTML: { __html: definition } })));
};
